const PATH_TO_WALLET = '/wallet'

/**
 * Determine where we want to redirect user to after user login
 * @param {String} cachedRoute - The cachedRoute in the state
 * @param {Object} preLoginData - The preLoginData in the state
 * @param {String} fallbackRoute - (optional) The fallback route to redirect to
 * @returns {String}
 */
export const determineRedirectRouteAfterLogin = (cachedRoute, preLoginData, fallbackRoute = PATH_TO_WALLET) => {

  let redirectRoute = cachedRoute

  if (preLoginData.qrCodeUrl && preLoginData.qrCodeUrlExpiresAt) {
    if (Date.now() < preLoginData.qrCodeUrlExpiresAt) {
      // it hasn't expired yet, redirect to qrCodeUrl
      redirectRoute = preLoginData.qrCodeUrl
    } else {
      // qrCodeUrl has expired
      // if we redirect user to cart via cachedRoute it will cause problems
      // redirect user to wallet instead
      redirectRoute = PATH_TO_WALLET
    }
  }

  if (!redirectRoute) {
    redirectRoute = fallbackRoute
  }

  return redirectRoute
}
